<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M88.9216 72.1237H8.92798C6.47142 72.1237 4.47998 74.1151 4.47998 76.5717V199.944C4.47998 202.401 6.47142 204.392 8.92798 204.392H88.9216C91.3782 204.392 93.3696 202.401 93.3696 199.944V76.5717C93.3696 74.1151 91.3782 72.1237 88.9216 72.1237Z"
      class="fill-secondary-500"
    />
    <path
      d="M64.9664 91.3621H32.8832C27.652 91.3621 23.4112 95.6028 23.4112 100.834V171.068C23.4112 176.299 27.652 180.54 32.8832 180.54H64.9664C70.1976 180.54 74.4384 176.299 74.4384 171.068V100.834C74.4384 95.6028 70.1976 91.3621 64.9664 91.3621Z"
      class="fill-brand-300"
    />
    <path
      d="M57.472 115.528C57.472 120.245 53.6448 124.072 48.928 124.072C44.2112 124.072 40.384 120.245 40.384 115.528C40.384 110.812 44.2112 106.984 48.928 106.984C53.6448 106.984 57.472 110.812 57.472 115.528Z"
      class="fill-accent-500"
    />
    <path
      d="M23.4112 136.175V171.068C23.4112 176.303 27.6544 180.54 32.8832 180.54H64.96C70.1952 180.54 74.432 176.296 74.432 171.068V136.175H23.4112Z"
      class="fill-accent-500"
    />
    <path
      d="M51.1616 149.826H46.688C45.4367 149.826 44.4224 150.84 44.4224 152.092V164.757C44.4224 166.008 45.4367 167.023 46.688 167.023H51.1616C52.4128 167.023 53.4272 166.008 53.4272 164.757V152.092C53.4272 150.84 52.4128 149.826 51.1616 149.826Z"
      class="fill-brand-100"
    />
    <path
      d="M220.256 85.8581C213.645 76.1365 203.866 69.1285 192.173 66.2229C191.507 65.9285 190.816 65.6725 190.086 65.4869L135.181 51.5989C128.198 49.8325 121.037 54.1013 119.27 61.0837C117.504 68.0661 121.773 75.2277 128.755 76.9941L151.552 82.7605H70.8864C63.648 82.7605 57.4848 88.3861 57.2288 95.6245C56.96 103.221 63.0336 109.461 70.5664 109.461H106.214C103.891 111.842 102.458 115.087 102.458 118.677V118.972C102.458 123.778 105.037 127.976 108.883 130.28C105.043 132.591 102.458 136.783 102.458 141.596V141.89C102.458 148.021 106.637 153.154 112.301 154.645C111.686 156.802 111.59 159.183 112.346 161.685C113.978 167.08 119.078 170.677 124.717 170.677H176.269C191.315 169.992 200.39 165.628 207.386 161.231C208.864 160.303 210.278 159.221 211.635 158.018H250.669V85.8581H220.256Z"
      class="fill-brand-100"
    />
    <path
      d="M135.181 51.5988C131.046 50.5556 126.861 51.6308 123.763 54.1268C125.21 56.0788 127.782 58.4724 129.914 59.2532C135.45 61.2692 141.99 61.602 141.99 61.602C144.058 62.0308 145.805 60.1172 146.266 57.9156L146.56 54.4852L135.181 51.6052V51.5988Z"
      class="fill-brand-300"
    />
    <path
      d="M251.648 85.8068V158.063C251.648 160.962 249.293 163.311 246.4 163.311H226.093V80.5524H246.4C249.299 80.5524 251.648 82.9076 251.648 85.8004V85.8068Z"
      class="fill-brand-500"
    />
    <path
      d="M77.5872 103.196H70.5088C66.3104 103.196 62.8992 99.7845 62.8992 95.5861C62.8992 91.3877 66.3104 87.9765 70.5088 87.9765H77.5872C78.4192 87.9765 79.0912 88.6549 79.0912 89.4805V101.679C79.0912 102.511 78.4128 103.183 77.5872 103.183V103.196Z"
      class="fill-brand-300"
    />
  </svg>
</template>

<script>
  export default {
    name: 'PowerOutage'
  }
</script>
